/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Ukm_D1dInputs */

const en_mk_sol_ukm_d1d = /** @type {(inputs: Mk_Sol_Ukm_D1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A scheduled routine runs the Finance agent before the office opens; the result posts into the daily-recap channel, ready to read over breakfast.`)
};

const id_mk_sol_ukm_d1d = /** @type {(inputs: Mk_Sol_Ukm_D1dInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rutinitas terjadwal menjalankan agen Finance sebelum kantor buka; hasilnya masuk ke channel rekap-harian, siap dibaca sambil sarapan.`)
};

/**
* | output |
* | --- |
* | "A scheduled routine runs the Finance agent before the office opens; the result posts into the daily-recap channel, ready to read over breakfast." |
*
* @param {Mk_Sol_Ukm_D1dInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_ukm_d1d = /** @type {((inputs?: Mk_Sol_Ukm_D1dInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Ukm_D1dInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_ukm_d1d(inputs)
	return en_mk_sol_ukm_d1d(inputs)
});